import React from 'react';
import { motion } from 'framer-motion';

const NoticeSection = () => {
  return (
    <motion.section 
      className="bg-gradient-to-r from-yellow-600 to-orange-600 py-8"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="container mx-auto px-4">
        <div className="text-center text-black">
          <h3 className="text-xl font-bold mb-4">⚠️ Notice</h3>
          <p className="text-sm md:text-base leading-relaxed mb-4">
            This website is created only for student practice. Account4Web experts have not fixed technical issues here – so you can clearly see the real work level of students. Almost 80% of the website is perfect, and the remaining 20% is polished by experts in final projects.
          </p>
          <p className="text-sm md:text-base leading-relaxed mb-4">
            🔒 We never share any client website made under this offer with others – your project privacy is 100% safe.
          </p>
          <a 
            href="https://projects.azaansuperpc.com/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="inline-block bg-black text-white px-6 py-2 rounded-lg font-medium hover:bg-gray-800 transition-colors"
          >
            👉 Check Offer
          </a>
        </div>
      </div>
    </motion.section>
  );
};

export default NoticeSection;